import { render, staticRenderFns } from "./ActivityTabEmails.vue?vue&type=template&id=5f93bea9&"
import script from "./ActivityTabEmails.vue?vue&type=script&lang=js&"
export * from "./ActivityTabEmails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports